import styled from 'styled-components';
import get from 'lodash/get';

import { colors } from '@/constants/theme';

import { borderColors, componentColors } from './helpers';

export const Component = styled.span<{ color: string }>`
  padding: 5px 10px;

  background: ${colors.white};
  border: 1px solid ${({ color }) => get(borderColors, color)};

  box-sizing: border-box;
  backdrop-filter: blur(10px);

  border-radius: 6px;
  font-weight: 700;
  color: ${({ color }) => get(componentColors, color)};

  white-space: nowrap;
`;
